import * as React from 'react';
export const PLSvg = React.forwardRef(function PLSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F6F9FC',
        d: 'M1.994 2A1.998 1.998 0 0 0 0 3.998V8h16V3.998A1.997 1.997 0 0 0 14.006 2H1.994Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#EAEEF3',
        fillRule: 'nonzero',
        d: 'M14 2a2 2 0 0 1 2 2v4h-1V4a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v4H0V4a2 2 0 0 1 2-2h12Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M0 8v4.002C0 13.106.895 14 1.994 14h12.012A1.998 1.998 0 0 0 16 12.002V8H0Z',
      }),
    ),
  );
});
PLSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var PL = {
  category: 'flag',
  colorable: false,
  name: 'PL',
  svg: PLSvg,
};
